import { parseQueryString } from "@catchoftheday/utilities";

export function getSourceValuesFromQueryString() {
  let sourceValues: Record<string, string | undefined> = {};
  if (typeof window !== "undefined") {
    sourceValues = parseQueryString(window.location.search);
  }
  const { sid, st, sp } = sourceValues;
  return {
    sourceId: sid,
    sourceType: st ? parseInt(st) : undefined,
    sourcePosition: sp ? parseInt(sp) : undefined,
  };
}
